import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { get, del, patch, post } from 'aws-amplify/api';
import { BulkDeleteResponse, NotificationHistoryResponse } from '../interface/notification-history.interface';
@Injectable({ providedIn: 'root' })
export class NotificationHistoryService {
  private async readJson<T>(op: { response: Promise<{ body: { json(): Promise<any> } }> }): Promise<T> {
    const r = await op.response;
    return (await r.body.json()) as T;
  }

  public getNotificationHistory(): Observable<NotificationHistoryResponse[]> {
    const op = get({ apiName: 'portal', path: 'adhoc/scheduled/history' });
    return from(this.readJson<NotificationHistoryResponse[]>(op));
  }

  public deleteNotification(id: string): Observable<NotificationHistoryResponse[]> {
    const op = del({ apiName: 'portal', path: `adhoc/scheduled/${id}/deletemessage` });
    return from(this.readJson<NotificationHistoryResponse[]>(op));
  }

  public updateNotification(
    payload: NotificationHistoryResponse,
    id: string
  ): Observable<NotificationHistoryResponse[]> {
    const body = JSON.parse(JSON.stringify(payload)) as Record<string, any>;
    const op = patch({
      apiName: 'portal',
      path: `adhoc/scheduled/editMessage/${id}/update`,
      options: { body },
    });
    return from(this.readJson<NotificationHistoryResponse[]>(op));
  }

  public getRecipientsAttribute(id: string): Observable<any> {
    const op = get({ apiName: 'portal', path: `adhoc/scheduled/showRecipientsDetails/${id}` });
    return from(this.readJson<any>(op));
  }

  public bulkDeleteNotifications(ids: string[]): Observable<BulkDeleteResponse> {
    const op = post({
      apiName: 'portal',
      path: 'adhoc/scheduled/bulk-delete',
      options: { body: { ids } },
    });
    return from(this.readJson<BulkDeleteResponse>(op));
  }
}
